import {CritèreRecherche} from "../CritèreRecherche.js";
import {FenêtreSurgissante} from "./FenêtreSurgissante.js";
import {getNombreFr_CA} from "../dom.js";

export class TableauRecherches extends HTMLElement {

    static nom = "tableau-recherches";

    static Événements = Object.freeze(
        {
            "RECHERCHE_HISTORIQUE_SUPPRESSION": "recherche-historique-suppression",
            "RECHERCHE_HISTORIQUE_PARTAGE": "recherche-historique-partage",
            "RECHERCHE_HISTORIQUE_EXÉCUTER": "recherche-historique-exécuter",
            "RECHERCHE_HISTORIQUE_VIDER": "recherche-historique-vider",
            "RECHERCHE_FAVORI_SUPPRESSION": "recherche-favori-suppression",
            "RECHERCHE_FAVORI_PARTAGE": "recherche-favori-partage",
            "RECHERCHE_FAVORI_EXÉCUTER": "recherche-favori-exécuter",
            "RECHERCHE_FAVORI_AJOUTER": "recherche-favori-ajouter",
            "RECHERCHE_FAVORI_VIDER": "recherche-favori-vider",
            "RECHERCHE_FAVORI_RENOMMER": "recherche-favori-renommer",
        }
    );

    static observedAttributes = ["type", "abrégé"];

    shadowRoot;
    type;
    abrégé;
    // Seulement utilisé pour type = "favori".
    favorisHashes = new Set();

    // Pour n'avoir qu'un seul listener de fermeture de toutes les fenêtre modale ouverte par le composant FenêtreSurgissante
    fenêtreSurgissanteFermetureCourant = function (){};

    constructor() {
        super();

        // https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_templates_and_slots
        let template = document.getElementById("tableauRecherches");
        let templateContent = template.content;
        this.shadowRoot = this.attachShadow({mode: "open"});
        this.shadowRoot.appendChild(templateContent.cloneNode(true));

        this.tbodyÉlément = this.shadowRoot.getElementById("historique-lignes");

        this.shadowRoot.getElementById("tableau-action-vider").addEventListener("click", (e) => this.envoieÉvénementViderTableau(e));

        customElements.get(FenêtreSurgissante.nom) || customElements.define(FenêtreSurgissante.nom, FenêtreSurgissante);
        this.fenêtreSurgissanteÉlément = new FenêtreSurgissante();
        this.fenêtreSurgissanteÉlément.addEventListener(FenêtreSurgissante.Événements.FENÊTRE_SURGISSANTE_FERMETURE, (e) => {
            this.fenêtreSurgissanteFermeture(e);
        });
        this.shadowRoot.appendChild(this.fenêtreSurgissanteÉlément);

    }

    setFavorisHashes(favoriHashes) {
        this.favorisHashes = favoriHashes;
    }

    affiche(recherches) {

        // Attention performances : plutôt ajouter/insérer dans DOM uniquement  les recherches dont le TS n'y est
        // pas déjà, supprimer celles qui n'y sont pas.
        this.tbodyÉlément.innerText = null;

        recherches.forEach((recherche) => {

            const tr = document.createElement("tr");

            const critèresTdÉlément = this.getCritèresÉlément(recherche);
            const optionsTdÉlément = this.getOptionsÉlément(recherche);
            const actionsTdÉlément = this.getActionsÉlément(recherche);
            const nbItemsTdÉlément = this.getNbItemsÉlément(recherche);

            tr.appendChild(actionsTdÉlément);
            tr.appendChild(critèresTdÉlément);
            tr.appendChild(optionsTdÉlément);
            tr.appendChild(nbItemsTdÉlément);

            this.tbodyÉlément.appendChild(tr);

        })


    }

    getSupprimerAction(recherche) {
        /*
        <i id="supprimeTousLesCritères" class="icon i-poubelle" title="Supprimer tous les critères" style="display: block;"></i>
         */
        const iÉlément = document.createElement("i");
        iÉlément.classList.add("icon", "i-poubelle");
        iÉlément.title = "Supprimer la recherche " + (this.type === "historique" ? "de l'historique" : "des favoris");
        iÉlément.addEventListener("click", (e) => {
            this.envoieÉvénementSuppression(e, recherche)
        })

        return iÉlément;

    }

    getPartagerAction(recherche) {


        const iÉlément = document.createElement("i");
        iÉlément.classList.add("icon", "i-partage-media-sans-cercle");
        iÉlément.title = "Partager la recherche";
        iÉlément.addEventListener("click", (e) => {
            this.envoieÉvénementPartage(e, recherche)
        })

        return iÉlément;

    }

    getExécuterAction(recherche) {


        const iÉlément = document.createElement("i");
        iÉlément.classList.add("icon", "i-executer");
        iÉlément.title = "Exécuter la recherche";
        iÉlément.addEventListener("click", (e) => {
            this.envoieÉvénementExécuter(e, recherche)
        })

        return iÉlément;

    }

    getAjouterAuxFavorisAction(recherche) {

        const iÉlément = document.createElement("i");

        if (this.favorisHashes && this.favorisHashes.has(recherche.hash)) {
            iÉlément.title = "Retirer des favoris";
            iÉlément.classList.add("icon", "i-favori-plein", "actif");
        } else {
            iÉlément.classList.add("icon", "i-favori-vide");
            iÉlément.title = "Ajouter aux favoris";
        }

        iÉlément.addEventListener("click", (e) => this.traiteFavorisAjoutOuSuppression(e, recherche, iÉlément));

        return iÉlément;

    }

    getÉditerNomAction(recherche) {

        const iÉlément = document.createElement("i");

        iÉlément.classList.add("icon", "i-crayon");
        iÉlément.title = "Éditer le nom de la recherche";

        iÉlément.addEventListener("click", (e) => this.traiteÉditionNom(e, recherche, iÉlément));

        return iÉlément;

    }

    getNbItemsÉlément(recherche) {
        const nbItemsTdÉlément = document.createElement("td");
        nbItemsTdÉlément.classList.add("recherche-nbRésultats");
        nbItemsTdÉlément.textContent = getNombreFr_CA(recherche.nbTotalItems);
        return nbItemsTdÉlément;
    }

    getActionsÉlément(recherche) {

        const actionsTdÉlément = document.createElement("td");
        const divÉlément = document.createElement("div");

        divÉlément.classList.add("actionsLigneTableau");

        divÉlément.appendChild(this.getSupprimerAction(recherche));

        if (this.type === "historique") {
            divÉlément.appendChild(this.getAjouterAuxFavorisAction(recherche));
        }
        if(this.type === "favori") {
            divÉlément.appendChild(this.getÉditerNomAction(recherche));
        }

        divÉlément.appendChild(this.getPartagerAction(recherche));
        divÉlément.appendChild(this.getExécuterAction(recherche));


        actionsTdÉlément.appendChild(divÉlément);

        return actionsTdÉlément;
    }

    getOptionsÉlément(recherche) {
        const optionsTdÉlément = document.createElement("td");
        const divOptionsÉlément = document.createElement("div");
        divOptionsÉlément.classList.add("recherche-options");
        optionsTdÉlément.appendChild(divOptionsÉlément);

        let nomFiltre = CritèreRecherche.getNomFiltre(recherche.options);

        const divOptionÉlément = document.createElement("div");
        divOptionÉlément.classList.add("recherche-option");
        const spanNom = document.createElement("span");
        spanNom.classList.add("recherche-option-nom");
        spanNom.innerText = nomFiltre;
        divOptionÉlément.appendChild(spanNom);

        divOptionsÉlément.appendChild(divOptionÉlément)

        return optionsTdÉlément;
    }

    getCritèresÉlément(recherche) {
        const critèresTdÉlément = document.createElement("td");

        const nomÉlément = document.createElement("div");

        nomÉlément.id = this.getNomRechercheId(recherche);
        nomÉlément.innerText = recherche.nom;
        nomÉlément.classList.add("recherche-nom");
        if(!recherche.nom || recherche.nom.trim().length === 0) {
            nomÉlément.style.display = "none";
        }
        critèresTdÉlément.appendChild(nomÉlément);

        const divÉlément = document.createElement("div");
        divÉlément.classList.add("recherche-critères");
        critèresTdÉlément.appendChild(divÉlément);

        [...recherche.critères.keys()].sort().forEach((code) => {
            divÉlément.appendChild(CritèreRecherche.asDiv(recherche.critères.get(code), this.abrégé));
        })

        return critèresTdÉlément;
    }

    getNomRechercheId(recherche) {
        return "favori-" + recherche.hash;
    }

    majNomRecherche(recherche) {
        const nomRechercheÉlément = this.shadowRoot.getElementById(this.getNomRechercheId(recherche));
        if(nomRechercheÉlément) {
            if(!recherche.nom || recherche.nom.trim().length === 0) {
                nomRechercheÉlément.innerText = "";
                nomRechercheÉlément.style.display = "none";
            }
            else {
                nomRechercheÉlément.innerText = recherche.nom;
                nomRechercheÉlément.style.display = "block";
            }
        }

    }

    envoieÉvénementSuppression(e, recherche) {
        const nomÉvénement = this.type === "historique"
            ? TableauRecherches.Événements.RECHERCHE_HISTORIQUE_SUPPRESSION
            : TableauRecherches.Événements.RECHERCHE_FAVORI_SUPPRESSION;
        this.dispatchEvent(new CustomEvent(nomÉvénement, {
            detail: {recherche: recherche},
            bubbles: true,
            composed: true
        }))
    }

    envoieÉvénementPartage(e, recherche) {
        const nomÉvénement = this.type === "historique"
            ? TableauRecherches.Événements.RECHERCHE_HISTORIQUE_PARTAGE
            : TableauRecherches.Événements.RECHERCHE_FAVORI_PARTAGE;
        this.dispatchEvent(new CustomEvent(nomÉvénement, {
            detail: {recherche: recherche},
            bubbles: true,
            composed: true
        }))
    }

    envoieÉvénementExécuter(e, recherche) {
        const nomÉvénement = this.type === "historique"
            ? TableauRecherches.Événements.RECHERCHE_HISTORIQUE_EXÉCUTER
            : TableauRecherches.Événements.RECHERCHE_FAVORI_EXÉCUTER;
        this.dispatchEvent(new CustomEvent(nomÉvénement, {
            detail: {recherche: recherche},
            bubbles: true,
            composed: true
        }))
    }

    traiteFavorisAjoutOuSuppression(e, recherche, iÉlément) {

        if (this.favorisHashes && this.favorisHashes.has(recherche.hash)) {
            iÉlément.title = "Retirer des favoris";
            iÉlément.classList.remove("actif");
            this.dispatchEvent(new CustomEvent(TableauRecherches.Événements.RECHERCHE_FAVORI_SUPPRESSION, {
                detail: {recherche: recherche},
                bubbles: true,
                composed: true
            }))

        } else {

            iÉlément.title = "Ajouter aux favoris";
            iÉlément.classList.add("actif");
            this.dispatchEvent(new CustomEvent(TableauRecherches.Événements.RECHERCHE_FAVORI_AJOUTER, {
                detail: {recherche: recherche},
                bubbles: true,
                composed: true
            }))
        }
    }

    traiteÉditionNom(e, recherche, iÉlément) {

        // Hack : récupérer le nom de la recherche via HTML car il pourrait avoir été modifié par le Gestionnaire de favoris
        // const nomRechercheÉlément = this.shadowRoot.querySelector(`/*[id$="${recherche.hash}"]*/`)
        const nomRechercheÉlément = this.shadowRoot.getElementById(this.getNomRechercheId(recherche));
        let nomRecherche = recherche.nom;
        if(nomRechercheÉlément) {
            nomRecherche = nomRechercheÉlément.innerText;
        }

        this.édite(nomRecherche, "Nom de la recherche",(retour) => {
            if (retour.confirmation === "oui") {
                this.dispatchEvent(new CustomEvent(TableauRecherches.Événements.RECHERCHE_FAVORI_RENOMMER, {
                    detail: {
                        recherche: recherche,
                        nouveauNom: retour.champs.texteÉditable,
                    },
                    bubbles: true,
                    composed: true
                }))
            }
        });


    }


    envoieÉvénementViderTableau(e) {
        let àSupprimer = "";
        let nomÉvénement = ""
        switch (this.type) {
            case "historique":
                àSupprimer = "l'historique de vos recherches";
                nomÉvénement = TableauRecherches.Événements.RECHERCHE_HISTORIQUE_VIDER;
                break;
            case "favori":
                àSupprimer = "vos recherches favorites";
                nomÉvénement = TableauRecherches.Événements.RECHERCHE_FAVORI_VIDER;
                break;
        }

        this.confirme(`Voulez-vous vraiment supprimer ${àSupprimer} ?`, (retour) => {
            if (retour.confirmation === "oui") {
                this.dispatchEvent(new CustomEvent(nomÉvénement, {
                    detail: {},
                    bubbles: true,
                    composed: true
                }));
            }
        });


    }


    connectedCallback() {
        this.type = this.getAttribute("type");
        const abrégéAttr = this.getAttribute("abrégé");
        this.abrégé = abrégéAttr && abrégéAttr === "oui";

        // C'est ici que le DOM pourrait être construit si pas template
        // Idem pour style (inline ou link)
    }

    disconnectedCallback() {
        // console.log("Custom element removed from page.");
    }

    adoptedCallback() {
        // console.log("Custom element moved to new page.");
    }

    attributeChangedCallback(name, oldValue, newValue) {
    }

    confirme(texte, fctRetour) {
        this.fenêtreSurgissanteFermetureCourant = fctRetour;
        this.fenêtreSurgissanteÉlément.confirme(texte);
    }

    édite(texte, label, fctRetour) {
        this.fenêtreSurgissanteFermetureCourant = fctRetour;
        this.fenêtreSurgissanteÉlément.édite(texte, label);
    }

    fenêtreSurgissanteFermeture(e) {
        this.fenêtreSurgissanteFermetureCourant(e.detail);
    }

}
